module.exports = __webpack_public_path__ + "static/PipeDrive-d5a5743317ccbb01eee0a8f008773f69.png";